<template>
	<dynvibebasechart
		:id="axiosComputed"
		ref="basechart"
		@created="chartCreated"
		:functionClick="clickGraph"
		:type="type"
	></dynvibebasechart>
</template>
<script>
import graphMixin from "@/mixins/graphMixin.js";
export default {
	name: "dynamicbubble",
	props: {
		xTitle: {
			type: String,
			default: "",
		},
		yTitle: {
			type: String,
			default: "",
		},
	},
	mixins: [graphMixin],

	data() {
		return {
			series: {},
		};
	},
	methods: {
		chartCreated() {
			this.baseChart = this.$refs.basechart;
			this.setChartOptions();
		},

		setChartOptions() {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();

			chartOptions.colors = this.graphColor;
			chartOptions.chart.type = "bubble";
			chartOptions.chart.plotBorderWidth = 1;
			chartOptions.chart.zoomType = "xz";
			chartOptions.xAxis.title = {
				enabled: true,
				text: this.xTitle,
			};
			chartOptions.xAxis.startOnTick = true;
			chartOptions.xAxis.endOnTick = true;
			chartOptions.xAxis.showLastLabel = true;

			chartOptions.yAxis.title = {
				enabled: true,
				text: this.yTitle,
			};

			chartOptions.plotOptions = {
				series: {
					dataLabels: {
						enabled: false,
						format: "{point.topic}",
					},
					states: {
						inactive: {
							opacity: 1,
						},
					},
					point: {
						// To see bubble with the same topic
						events: {
							mouseOver: function () {
								let thisSeries = this.series,
									allSeries = thisSeries.chart.series;

								allSeries.forEach((s) => {
									s.points.forEach((point) => {
										if (!point.topic.includes(this.topic)) {
											point.update({ color: thisSeries.chart.options.colors[point.colorIndex] + "11" }, false);
										}
									});
								});
								thisSeries.chart.redraw();
							},
							mouseOut: function () {
								let thisSeries = this.series,
									allSeries = thisSeries.chart.series;

								allSeries.forEach((s) => {
									s.points.forEach((point) => {
										point.update({ color: thisSeries.chart.options.colors[point.colorIndex] }, false);
									});
								});
								thisSeries.chart.redraw();
							},
						},
					},
					events: {
						// Display only the selected category on click
						legendItemClick: function () {
							let seriesIndex = this.index;
							let series = this.chart.series;

							if (this.visible && this.chart.restIsHidden) {
								for (let i = 0; i < series.length; i++) {
									if (series[i].index != seriesIndex) {
										series[i].show();
									}
								}
								this.chart.restIsHidden = false;
							} else {
								for (let i = 0; i < series.length; i++) {
									if (series[i].index != seriesIndex) {
										series[i].hide();
									}
								}
								this.show();
								this.chart.restIsHidden = true;
							}
							return false;
						},
						click: this.clicked,
					},
				},
			};

			if (this.axiosComputed == "categoriesdynamic") {
				chartOptions.tooltip = {
					hideDelay: 100,
					useHTML: true,
					headerFormat: "<div>",
					pointFormat:
						"<h4>{point.topic}</h4>" +
						"<p>Dynamic: {point.x}%<br>" +
						"Volume / profile: {point.y} posts<br>" +
						"Volume total: {point.z} posts</p>",
					footerFormat: "</div>",
					followPointer: true,
				};
			}

			baseChart.updateChartOptions(chartOptions);
		},
		loadChartData(results /*, toload = true*/) {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();
			let iter = results.categories.keys();
			chartOptions.xAxis.categories = iter.next();
			chartOptions.series = results.values;
			this.series = results.values;

			baseChart.updateChartOptions(chartOptions);
		},
		clicked(item) {
			this.$emit("clicked", {
				keyword: item.point.topic,
				country: item.point.series.name,
			});
		},
	},
};
</script>
<style>
.highcharts-tooltip > span {
	background: rgba(255, 255, 255, 0.85);
	border: 1px solid silver;
	border-radius: 3px;
	box-shadow: 1px 1px 2px #888;
	padding: 8px;
	z-index: 1000;
}

.highchart-growth-up {
	background-color: #23056b;
	color: #fff;
	font-size: 9px;
	padding: 4px;
	position: inherit;
	left: -25px;
	top: -25px;
	z-index: 1;
}

.highchart-growth-down {
	background-color: #fe5c5d;
	color: #fff;
	font-size: 9px;
	padding: 4px;
	position: inherit;
	left: -25px;
	top: -25px;
	z-index: 1;
}
</style>
